import type { Tab } from "../navigation.ts";

export function isLocalLlmViewActive(host: { tab: Tab }): boolean {
  return host.tab === "local-llm" || host.tab === "llm-stats";
}
